<template lang="pug">
h5.smart-control-drive {{ $t(`${baseTranslationPath}.title`) }}

.field-container.full-width.padding-top
    label {{ $t(`${baseTranslationPath}.select_rule`) }}
    aiq-select(v-model="selectedRule"
                  :max-length="250"
                  value-key="id"
                  @change = "itemChanged"
                  :clearable="true")
        aiq-option(v-for="item in rules",
                        :key="item.id",
                        :label="item.name",
                        :value="item")
.field-container.full-width.padding-top(v-if="itemSelected")
    label {{ $t(`${baseTranslationPath}.version`) }}
    aiq-input(v-model="selectedRule.version"
                :max-length="250"
                )
.field-group(v-if="itemSelected")
    .group-item(v-for="(stage, index) in selectedRule.payload.stages" :key="stage.name")
        .field-container
            span.stage-name {{ stage.name }}
        .field-container.full-width.padding-top.is-required
            label {{ $t(`${baseTranslationPath}.select_agent_team`, {min: stage.min_assignee_count}) }}
            aiq-select(v-model="stage.assignees"
                        :max-length="250"
                        value-key="id"
                        multiple
                        :reserve-keyword="false")
                aiq-option(v-for="item in agentsAndTeams", :key="item.id", :label="item.name", :value="item")
</template>
<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { AGENT_LIMIT, RULES_LIMIT } from '@/constants/pagination';
export default {
  name: 'smart-control-drive',
  data() {
    return {
      agentsAndTeams: [],
      rules: [],
      isRuleSatisfied: false,
      itemSelected: false,
      defaultVersion: '1.0',
      selectedRule: {
        version: '1.0',
        payload: {
          stages: [],
        },
      },
      baseTranslationPath: 'settings_tab.smart_drive_tab.smart_control',
    };
  },
  emits: ['rule-satisfied'],
  watch: {
    selectedRule: {
      /**
 * Handler for selectedRule watcher.
 * Emits 'rule-satisfied' event with information about whether the selected rule is satisfied.
 * If the selected rule is null, it means the rule is satisfied and the event will be emitted with 'isRuleSatisfied' set to true.
 * If the selected rule is not null, it checks whether all stages in the rule have enough assignees and emits the event with 'isRuleSatisfied' set to the result of the check.
 */
      handler(newValue) {
        if (!newValue) {
          this.$emit('rule-satisfied', {
            isRuleSatisfied: true,
            selectedRule: null,
            versionSatisfied: true,
          });
        } else {
          const stages = get(newValue, 'payload.stages', []);
          const isRuleSatisfied = stages.every(stage => get(stage, 'assignees', []).length >= stage.min_assignee_count);
          const version = get(newValue, 'version', '');
          const versionSatisfied = !isEmpty(version);
          this.$emit('rule-satisfied', {
            isRuleSatisfied,
            versionSatisfied,
            selectedRule: newValue,
          });
        }
      },
      deep: true,
    },
  },
  props: {
    sortedTeams: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    await this.init();
  },

  methods: {
  /**
   * Initializes the component by fetching the list of agents and teams and storing them in 'agentsAndTeams'.
   * Also fetches the list of rules and stores them in 'rules'.
   */
    async init() {

      const params = {
        limit: RULES_LIMIT,
      };
      const agents = await this.$store.dispatch('agents/getAgentsList',
        [{limit: AGENT_LIMIT}, true],
      );
      const agent_data = get(agents, 'data.models', []);

      const agentSelectable = agent_data.map((agent) => {
        return {
          id: agent.id,
          name: agent.fullName,
          type: 'agent',
        };
      });
      const teamSelectable = this.sortedTeams.map((team) => {
        return {
          id: team.id,
          name: team.name,
          type: 'team',
        };
      });
      this.agentsAndTeams = [...agentSelectable, ...teamSelectable];


      const rules = await this.$store.dispatch(
        'smartControl/getRuleList',
        [params, true],
      );

      this.rules = get(rules, 'data.models', []);
    },
    itemChanged(item) {
      if (!item) {
        this.itemSelected = false;
      } else {
        this.itemSelected = true;
        this.selectedRule.version = this.defaultVersion;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.stage-name {
  font-weight: bold;
  font-size: 14px;
}
.smart-control-drive {
  margin-bottom: 20px;
  margin-top: 20px;
}
.padding-top {
  padding-top: 10px;
}
.btn {
  display: flex;
  justify-content: flex-end;
}
</style>
